<div class="progress relative overflow-hidden" [ngClass]="{'show-shadow': showShadow()}">
  <svg class="progress-svg"
       [attr.width]="hostSize().w"
       [attr.height]="hostSize().h"
  >

    <!-- main line -->
    <line [attr.x1]="padding" [attr.x2]="hostSize().w - padding"
          [attr.y1]="centerY()" [attr.y2]="centerY()"
          stroke="#383838" stroke-width="8" stroke-linecap="square"/>

    <!-- active line -->
    <line [attr.x1]="padding" [attr.x2]="valueX()"
          [attr.y1]="centerY()" [attr.y2]="centerY()"
          stroke="#D3FF07" stroke-width="8" stroke-linecap="square"/>

    <!-- points -->
    @for (p of coords(); track $index) {
      @if ($index > 0) {
        <circle [attr.cx]="p.x" [attr.cy]="centerY()" r="4"
                [attr.fill]="p.active ? '#D3FF07' : '#383838'"
        />
      }

      @if(p.label) {
        <text
          class="label text-12 sm:text-10 font-weight-500"
          [attr.x]="p.x"
          [attr.y]="labelPosition() === 'top'
                   ? centerY() - 18
                   : centerY() + 30"
          font-size="12"
          text-anchor="middle"
          [attr.class]="labelClass()"
          [ngClass]="{active: p.active}"
          fill="#555">
          {{ p.label }}
        </text>
      }
    }
  </svg>
</div>
